<template>
  <section
    data-background-video="/img/presentationbackgrounds/weed.mp4"
    data-background-video-loop="true"
    data-background-opacity="0.5"
    id="circleOfLife"
  >

  <div
      class="sl-block"
      data-block-type="text"
      style="width: 800px; height:600px;  margin: auto; background-image: url('/img/CircleOfLife2.png; background-size: contain; background-position: center center"

    >
      
    </div>
 
   

  
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/harvestTime.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/harvestTime.mp4";
    }
    this.refresh();
  },
  mounted() {},
  data() {
    return {
      moment: moment,
      harvestSchedule: [],
      gifUrl: null,
      videoUrl: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
    pages() {
      let pages = [];
      for (let i=0; i<this.value.length; i++) {
        if (i % 8 == 0) {
          pages[pages.length] = [];
        }
        pages[pages.length - 1].push(this.value[i]);
      }
      return pages;
    }
  },
  watch: {},
  methods: {
    refresh() {
   
    },
  },
};
</script>
<style>
</style>

